import { createSlice } from '@reduxjs/toolkit';

import { withEdsUserFields } from '~/utils/user';

import { State } from './types';

const initialState = {} as State;

export default createSlice({
  name: 'currentUser',
  initialState,
  selectors: {
    selectCurrentUser: (state: State) => state,
  },
  reducers: {
    setCurrentUser: (_state, action) => withEdsUserFields(action.payload),
  },
});
